<template>
  <div class="content">
    <div class="mask" v-show="maskShow"></div>
    <div class="banner">
      <img src="../../img/mobile/Banner.png" />
    </div>
    <el-form class="checkNum" label-width="0" :model="validateForm" ref="validateForm">
      <div class="personal">
        <img src="../../img/mobile/personal.png" />
        <span>{{name}}</span>
      </div>
      <div class="title-container">
        <p class="title">手机号码</p>
      </div>
      <el-form-item
        prop="telphone"
        class="telphone"
        :rules="[{required: true,validator: checkPhone, trigger: 'change' }]"
      >
        <el-input placeholder="手机号" v-model="validateForm.telphone" :readonly="readonly">
          <template slot="prepend">+86</template>
        </el-input>
        <img
          class="del"
          src="../../img/mobile/del.png"
          @click="del()"
          :style="{'pointer-events': readonly ? 'none' : ''} "
          v-if="delFlag"
        />
      </el-form-item>
      <el-form-item
        prop="incode"
        class="incode"
        :rules="[{required: true,validator: checkCode, trigger: 'change' }]"
      >
        <el-input placeholder="请输入验证码" v-model="validateForm.incode" maxlength="6"></el-input>
        <div class="indent-btn" @click="countDown()">{{countd.content}}</div>
      </el-form-item>
    </el-form>
    <el-button
      type="primary"
      :disabled="phoneFlag === 1 && codeFlag === 1 ? false : true"
      @click="confirm('validateForm')"
      v-loading.fullscreen.lock="fullscreenLoading"
    >下一步</el-button>
    <dialogs
      :maskShow="maskShow"
      :employeeCode="employeeCode"
      :userName="userName"
      :currentPhone="currentPhone"
      :oldPhone="oldPhone"
    ></dialogs>
    <tipBox v-bind.sync="showBombTips" :tipsContent="tipsContent"></tipBox>
  </div>
</template>
<script>
import dialogs from "../../components/mobile/dialogs";
import tipBox from "../..//components/mobile/tipBox";
export default {
  components: {
    dialogs,
    tipBox
  },
  props: [],
  data() {
    return {
      phoneFlag: 0,
      codeFlag: 0,
      name: "",
      maskShow: false,
      employeeCode: "",
      userName: "",
      currentPhone: "",
      oldPhone: "",
      editAllow: "",
      delFlag: false,
      readonly: false,
      showBombTips: {
        visible: false
      },
      tipsContent: "",
      start: "",
      countd: {
        content: "获取验证码",
        totalTime: 60,
        isSecond: true
      },
      validateForm: {
        telphone: "",
        incode: ""
      },
      fullscreenLoading: false
    };
  },
  methods: {
    checkPhone(rule, value, callback) {
      if (!value) {
        this.phoneFlag = 0;
        this.delFlag = false;
      } else {
        this.phoneFlag = 1;
        this.delFlag = true;
        // localStorage.setItem("currentPhone", value);
        this.$cookieStore.setCookie('currentPhone', value)
      }
    },
    checkCode(rule, value, callback) {
      if (!value) {
        this.codeFlag = 0;
      } else {
        this.codeFlag = 1;
      }
    },
    /* 倒计时 */
    countDown() {
      var that = this;
      if (!that.validateForm.telphone) {
        that.showBombTips = {
          visible: true
        };
        that.tipsContent = "请输入手机号";
        return;
      } else {
        var reg = /^1[0|1|2|3|4|5|6|7|8|9][0-9]\d{8}$/;
        if (reg.test(that.validateForm.telphone)) {
          // 倒计时
          if (that.countd.isSecond) {
            var timer = setInterval(function() {
              that.countd.totalTime--;
              that.countd.content = that.countd.totalTime + "s";
              that.countd.isSecond = false;
              if (that.countd.totalTime <= 0) {
                that.countd.content = "获取验证码";
                that.countd.isSecond = true;
                that.countd.totalTime = 60;
                clearInterval(timer);
              }
            }, 1000);
          } else {
            console.log("验证码发送中，请稍候再试");
          }
        } else {
          that.showBombTips = {
            visible: true
          };
          that.tipsContent = "请输入正确的手机号";
          return;
        }
        that.$api
          .getVerifyCode({
            phone: that.validateForm.telphone
          })
          .then(res => {
            if (res.data.code === 0) {
              that.showBombTips = {
                visible: true
              };
              that.tipsContent = "验证码已发送";
              that.start = res.data.data;
              that.currentPhone = res.data.data;
            } else {
              that.showBombTips = {
                visible: true
              };
              that.tipsContent = "验证码已发送失败";
            }
          })
          .catch(res => {
            console.log(res);
          });
      }
    },
    confirm() {
      var that = this;
      that.fullscreenLoading = true;
      setTimeout(() => {
        that.fullscreenLoading = false;
      }, 500);
      var params = {
        employeeCode: this.$cookieStore.getCookie('workNum'),
        phone: that.validateForm.telphone,
        verifyCode: that.validateForm.incode,
        start: that.start
      };
      that.$api
        .checkVerifyCode(params)
        .then(res => {
          console.log(res.data);
          if (res.data.code === 0) {
            if (res.data.data === 0) {
              that.$router.push("/download");
            } else if (res.data.data === 1) {
              that.maskShow = !that.maskShow;
              that.$api
                .getUserInfo({
                  employeeCode: that.employeeCode
                })
                .then(res => {
                  that.userName = res.data.data.userName;
                  that.currentPhone = res.data.data.currentPhone;
                })
                .catch(res => {
                  console.log(res)
                });
            }
          } else if (res.data.code === 60004) {
            that.showBombTips = {
              visible: true
            };
            that.tipsContent = res.data.message;
          } else if (res.data.code === 60005) {
            that.showBombTips = {
              visible: true
            };
            that.tipsContent = res.data.message;
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    del() {
      this.validateForm.telphone = "";
      this.delFlag = false;
    }
  },
  mounted() {
    console.log(this.$cookieStore.getCookie('oldPhone'),'$cookieStore');
    var flag = this.$route.query.flag;
    if (flag === "1") {
      this.validateForm.telphone = this.$cookieStore.getCookie('oldPhone');
      this.oldPhone = this.$cookieStore.getCookie('oldPhone');
      this.editAllow = this.$cookieStore.getCookie('editAllow');
      this.employeeCode = this.$cookieStore.getCookie('workNum');
      this.name = this.$route.query.name;
      this.phoneFlag = 1;
      if (this.editAllow === "0") {
        this.readonly = false;
      } else {
        this.readonly = true;
      }
    } else if (flag === "0") {
      this.maskShow = this.maskShow;
      this.employeeCode = this.$cookieStore.getCookie('workNum');
      this.validateForm.telphone = this.$cookieStore.getCookie('currentPhone');
      this.oldPhone = this.$cookieStore.getCookie('oldPhone');
      this.name = this.$route.query.name;
      this.phoneFlag = 1;
    }
  },
  activated() {
    this.maskShow = false;
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  position: relative;
  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #000;
    opacity: 0.3;
  }
  .banner {
    height: 3.6rem;
    img {
      width: 7.5rem;
      height: 3.6rem;
    }
  }
  .personal {
    width: 4.52rem;
    height: 0.8rem;
    margin-top: 0.6rem;
    position: relative;
    img {
      width: 0.75rem;
      position: absolute;
      left: 0.45rem;
    }
    span {
      width: 2.52rem;
      line-height: 0.8rem;
      font-size: 0.42rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      position: absolute;
      left: 1.45rem;
      text-align: left;
    }
  }
  .title-container {
    .title {
      height: 0.48rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-size: 0.34rem;
      margin: 0.3rem 0rem 0.18rem 0.45rem;
      text-align: center;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      position: relative;
      left: -2.8rem;
    }
  }
  .telphone {
    position: relative;
    .del {
      width: 0.28rem;
      height: 0.28rem;
      position: absolute;
      top: 0.22rem;
      right: 0.2rem;
    }
  }
  .incode {
    position: relative;
    .indent-btn {
      width: 1.5rem;
      height: 0.4rem;
      font-size: 0.28rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(34, 142, 243, 1);
      line-height: 0.4rem;
      position: absolute;
      left: 5rem;
      top: 0.19rem;
    }
  }
  .el-form-item {
    width: 6.6rem;
    margin: 0rem 0.45rem 0.4rem 0.45rem;
  }
  >>> .el-input {
    width: 6.6rem;
    font-size: 0.25rem;
  }
  >>> .el-input__inner{
    height: 0.7rem;
    line-height: 0.7rem;
    font-size: 0.25rem;
  }
  >>> .el-button{
    font-size: 0.25rem;
  }
  .dialog {
    position: absolute;
    top: 4.44rem;
    left: 0.3rem;
    right: 0.3rem;
  }
  button {
    width: 6.6rem;
    height: 0.8rem;
    margin: 0rem 0.45rem;
    border-radius: 0.04rem;
    padding: 0.01rem 0rem;
    position: relative;
    left: 0rem;
    border: 0rem;
    outline: none;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }
  .confirmBtn {
    position: relative;
    left: 0rem;
    background-color: rgba(34, 142, 243, 1);
  }
  .opacityBtn {
    position: relative;
    left: 0rem;
    background-color: rgba(34, 142, 243, 1);
    opacity: 0.45;
  }
  .tipsBox {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/phoneNum.vue